"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.presaveSources = exports.PresaveReleaseStatuses = exports.MusicServiceTypes = void 0;
exports.MusicServiceTypes = ["apple", "spotify"];
exports.PresaveReleaseStatuses = [
    "scheduled",
    "success",
    "pending",
    "fail",
    "duplicate",
];
exports.presaveSources = [
    "setbio:section",
    "setbio:takeover",
    "setlive",
    "setfan",
    "auto",
];
//# sourceMappingURL=presave.js.map